import { QueryClient } from '@tanstack/react-query';
import { CubeQueryRecord } from '@/dev/types/cubeQueryTypes';
import type { CubejsApi } from '@/dev/services/RecordingState';
import { QueryRecorder } from '@/dev/services/QueryRecorder';
import { QueryStore } from '@/dev/services/QueryStore';
import { TabStateManager } from '@/dev/services/TabStateManager';

class CubeQueryExtractorService {
  private static instance: CubeQueryExtractorService;

  private queryStore: QueryStore;

  private queryRecorder: QueryRecorder;

  private tabStateManager: TabStateManager;

  private constructor() {
    this.queryStore = new QueryStore();
    this.tabStateManager = new TabStateManager();
    this.queryRecorder = new QueryRecorder(this.queryStore, this.tabStateManager);
  }

  static getInstance(): CubeQueryExtractorService {
    if (!CubeQueryExtractorService.instance) {
      CubeQueryExtractorService.instance = new CubeQueryExtractorService();
    }
    return CubeQueryExtractorService.instance;
  }

  subscribe(listener: () => void): () => void {
    return this.queryStore.subscribe(listener);
  }

  setCubejsApi(api: CubejsApi): void {
    this.queryRecorder.setCubejsApi(api);
  }

  setQueryClient(client: QueryClient): void {
    this.queryRecorder.setQueryClient(client);
  }

  startRecording(): void {
    this.queryRecorder.startRecording();
  }

  stopRecording(): void {
    this.queryRecorder.stopRecording();
  }

  getQueries(): CubeQueryRecord[] {
    return this.queryStore.getQueries();
  }

  getIsRecording(): boolean {
    return this.queryStore.getRecording();
  }

  getRecordingStartedAt(): number | null {
    return this.queryStore.getRecordingStartedAt();
  }

  deleteQuery(queryId: string): void {
    this.queryStore.deleteQuery(queryId);
  }

  updatePagePath(pagePath: string): void {
    this.queryRecorder.updatePagePath(pagePath);
  }
}

export const cubeQueryExtractor = CubeQueryExtractorService.getInstance();
